import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import HelpPopover from '../../HelpPopover';
import ZeroHeadingShortcutIcon from './zero-heading-shortcut.svg?react';

const ControllerZeroHeading = () => {
  const { t } = useTranslation();
  const label = t('controller.zeroHeading.label', 'Zero Heading');
  const tooltip = t('controller.zeroHeading.tooltip', 'Press L3 and R3 together to zero the robot heading before driving.');

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing={0.75}
      aria-label={label}
      sx={(theme) => ({
        color: theme.vars?.palette?.text?.primary,
        minHeight: 28,
      })}
    >
      <Box
        component={ZeroHeadingShortcutIcon}
        aria-hidden="true"
        sx={{
          display: 'block',
          width: 56,
          height: 'auto',
          flexShrink: 0,
          '& *': {
            stroke: 'currentColor !important',
          },
          '& .cls-4, & [style*="fill:#000000"], & [style*="fill: #000000"]': {
            fill: 'currentColor !important',
          },
          '& [style*="fill:none"], & [style*="fill: none"]': {
            fill: 'none !important',
          },
        }}
      />
      <Typography variant="body2" component="span" sx={{ lineHeight: 1.2 }}>
        {label}
      </Typography>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          color: 'text.primary',
          cursor: 'help',
          lineHeight: 0,
          '& svg': {
            fontSize: 18,
          },
        }}
      >
        <HelpPopover id="zero-heading-popover" text={tooltip} />
      </Box>
    </Stack>
  );
};

export default ControllerZeroHeading;
